
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { TaskActionModel } from './Entities.GormCrm.TaskAction';
import { Model, ModelProperty } from 'models/Model';


export class TaskAreaModel extends Model<TaskAreaModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'name', type: 'string' },
		{ name: 'color', type: 'string' },
		{ name: 'deleted', type: 'Date', isHidden: true },
		{ name: 'taskActions', type: 'TaskActionModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new TaskActionModel }, properties: () => { return TaskActionModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public name: string;
	public color: string;
	public deleted?: Date;
	public taskActions: TaskActionModel[];
    
	constructor(){
		super();
		this.id = undefined;
		this.name = '';
		this.color = '';
		this.deleted = undefined;
		this.taskActions = [];
		
	}
	getProperties(){
		return TaskAreaModel.classProperties;
	}
}

